<template>
  <div>
    <v-progress-linear v-if="cargando" indeterminate color="purple" class="mb-2" />

    <ag-grid-vue
      class="ag-theme-balham ag-grid-listado-montos-comisiones"
      colResizeDefault="shift"
      :animateRows="false"
      :floatingFilter="true"
      :alwaysShowVerticalScroll="true"
      :suppressPaginationPanel="true"
      :gridOptions="gridOptions"
      :defaultColDef="defaultColDef"
      :rowSelection="rowSelection"
      :pagination="pagination"
      :rowClassRules="rowClassRules"
      :columnDefs="columnDefs"
      :rowData="rowData"
      @grid-ready="onGridReady"
      @selection-changed="onSelectionChanged"
      @first-data-rendered="onFirstDataRendered">
    </ag-grid-vue>
  </div>
</template>
  
<script>
import listadoAgGridMixin from '../../mixins/listado-ag-grid.mixin';
import { MONEDAS_TEXTOS } from '../../utils/constantes';
import { cellRendererNumeroRegistro, cellRendererSiONo } from '../../utils/funciones';

export default {
  name: 'ListadoMontosComisiones',
  mixins: [listadoAgGridMixin],
  data() {
    return {
      columnDefs: [
        {
          headerName: 'N° REGISTRO',
          cellRenderer: cellRendererNumeroRegistro,
          filter: false,
          checkboxSelection: true,
          headerCheckboxSelectionFilteredOnly: true,
          headerCheckboxSelection: false,
          minWidth: 100,
          maxWidth: 100,
        },
        {
          headerName: 'CATEGORÍA',
          field: 'categoria.nombre',
          minWidth: 200,
        },
        {
          headerName: 'UNIDAD DE NEGOCIO',
          field: 'categoria.unidadNegocio.nombre',
          minWidth: 200,
        },
        {
          headerName: 'ES A MONTO',
          cellRenderer: cellRendererSiONo('esAMonto', 'SI', 'NO'),
          valueGetter: (params) => (params.data?.esAMonto ? 'SI' : 'NO'),
          minWidth: 120,
          maxWidth: 120,
        },
        {
          headerName: 'DESDE',
          field: 'desde',
          filter: 'agNumberColumnFilter',
          valueGetter: (params) =>
            params.data?.desde != null ? Number(params.data.desde) : null,
          cellRenderer: (params) => {
            return params.data?.desde || '-';
          },
          minWidth: 120,
          maxWidth: 120,
        },
        {
          headerName: 'HASTA',
          field: 'hasta',
          filter: 'agNumberColumnFilter',
          valueGetter: (params) =>
            params.data?.hasta != null ? Number(params.data.hasta) : null,
          cellRenderer: (params) => {
            return params.data?.hasta || '-';
          },
          minWidth: 120,
          maxWidth: 120,
        },
        {
          headerName: 'MONTO',
          field: 'monto',
          filter: 'agNumberColumnFilter',
          valueGetter: (params) =>
            params.data?.monto != null ? Number(params.data.monto) : null,
          cellRenderer: (params) => {
            return params.data?.monto || '-';
          },
          minWidth: 120,
          maxWidth: 120,
        },
        {
          headerName: 'COM. PLAN CONTADO',
          headerTooltip: 'Monto comisión plan contado',
          field: 'montoComisionPlanContado',
          filter: 'agNumberColumnFilter',
          valueGetter: (params) =>
            params.data?.montoComisionPlanContado != null
              ? Number(params.data.montoComisionPlanContado)
              : null,
          cellRenderer: (params) => {
            return params.data?.montoComisionPlanContado || '-';
          },
          minWidth: 160,
          maxWidth: 180,
        },
        {
          headerName: 'MONEDA',
          field: 'moneda',
          cellRenderer: (params) => {
            return MONEDAS_TEXTOS[params.data.moneda];
          },
          valueGetter: (params) => {
            return MONEDAS_TEXTOS[params.data.moneda];
          },
          filter: true,
          minWidth: 140,
          maxWidth: 140,
        },
        {
          headerName: 'PLAN COBRO PROGRAMA',
          field: 'nombrePlanCobroPrograma',
          cellRenderer: (params) => {
            return params.data?.nombrePlanCobroPrograma || '-';
          },
          minWidth: 220,
        },
        {
          headerName: 'INSTITUCIÓN',
          field: 'institucion.nombre',
          minWidth: 300,
          maxWidth: 300,
        },
      ],
    };
  },
};
</script>
  
<style>
@import '~ag-grid-community/dist/styles/ag-grid.css';
@import '~ag-grid-community/dist/styles/ag-theme-balham.css';

.ag-grid-listado-montos-comisiones {
  height: calc(var(--vh, 1vh) * 100 - 17rem);
}
</style>
  